export default __webpack_public_path__ + "static/media/refreshHover.617f3938.svg";